import { useState, useEffect } from 'react';
import Drawer, { DrawerHeader } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { FormFooter } from 'common/components/drawer';
import { FormBody } from 'common/components/drawer';

import Body from './Body';
import * as crewRankActions from 'store/crew-rank/actions';
import { useFormState, useForm } from 'utils/hooks';
import { Button } from 'reactstrap';
import config from './config';
import { useActions } from 'utils/hooks';

import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';

const Form = ({ drawer, active, isVisibility, refetchData, setIsVisibility }) => {
  const [submitting, setSubmitting] = useState(false);
  const { formState, loadValues, collectValues, resetForm } = useForm(config, { name: '' });
  const { fields, changeField, selectField } = useFormState(formState);

  const [createCrewRank, updateCrewRank] = useActions([
    crewRankActions.createCrewRank,
    crewRankActions.updateCrewRank
  ]);

  useEffect(() => {
    if (active) {
      loadValues({
        name: active.name,
        abbreviation: active.abbreviation,
        department: active.department,
        is_officer: active.is_officer
      });
    }
  }, [active, drawer.isOpen]);

  useEffect(() => {
    if (!drawer.isOpen) {
      setIsVisibility(false);
      resetForm();
    }
  }, [drawer.isOpen]);

  const onSubmit = async () => {
    try {
      setSubmitting(true);
      const values = collectValues();
      if (!values) {
        setSubmitting(false);
        return;
      }
      if (!active) {
        await createCrewRank({ ...values });
      } else {
        await updateCrewRank({ ...active, ...values });
      }
      setSubmitting(false);

      refetchData();

      drawer.close();
    } catch (e) {
      setSubmitting(false);
    }
  };

  return (
    <>
      <EditVisibilityForm
        drawer={drawer}
        active={active || {}}
        isOpen={drawer.isOpen && isVisibility}
        type="enums/crew-ranks"
      />
      <Drawer className="table-drawer" {...drawer} isOpen={drawer.isOpen && !isVisibility}>
        <DrawerHeader className="border-bottom pb-4">
          {active ? 'Edit Crew Rank' : 'Create New Rank'}
        </DrawerHeader>

        <FormDrawer>
          <FormBody>
            <Body fields={fields} changeField={changeField} selectField={selectField} />
          </FormBody>

          <FormFooter>
            <Button
              color="cancel"
              className="px-0 py-1 me-4"
              onClick={() => {
                drawer.close();
              }}
              disabled={submitting}
            >
              CANCEL
            </Button>
            <Button onClick={onSubmit} disabled={submitting} color="primary" className="px-4">
              {active ? 'SAVE' : 'CREATE'}
            </Button>
          </FormFooter>
        </FormDrawer>
      </Drawer>
    </>
  );
};

export default Form;
